import {
  injectPostMessage, clientWidgetFrameLoaded, makeJCFServerCommonChecks, injectGetStyle
} from '@jotforminc/widgets-js-sdk';

injectPostMessage();
injectGetStyle();
makeJCFServerCommonChecks();
window.widgetFrameLoaded = clientWidgetFrameLoaded;

export default {
  widgetFrameLoaded: clientWidgetFrameLoaded
};
